module.exports = __webpack_public_path__ + "img/微型电子锁 (1).ccfb4569.jpg";